import CountriesHome from './components/CountriesHome'

import './App.css'

// Replace your code here
const App = () => <CountriesHome />

export default App
